<tt-page *ngIf="!!page">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="p2_webpagelink_keyno" [ttModel]="page.p2_webpagelink_keyno" ttReadonly></tt-input>
        <tt-select
            ttLabel="p2_webpage_belongto"
            [(ttModel)]="page.p2_webpage_keyno_belongto"
            [ttData]="webpages"
            ttDataId="item_id"
            ttDataName="item_name"
            [ttReadonly]="page.p2_webpagelink_keyno === '0'">
        </tt-select>
        <tt-select
            ttLabel="p2_webpage"
            [(ttModel)]="page.p2_webpage_keyno"
            [ttData]="webpages"
            ttDataId="item_id"
            ttDataName="item_name">
        </tt-select>
        <tt-input ttLabel="params" [(ttModel)]="page.params"></tt-input>
        <tt-input-number ttLabel="orderby" [(ttModel)]="page.orderby" ttDecimals="0"></tt-input-number>
        <tt-input ttLabel="word_id" [(ttModel)]="page.word_id"></tt-input>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
